import { render, staticRenderFns } from "./TeleMarketDataNum.vue?vue&type=template&id=544bad31&scoped=true"
import script from "./TeleMarketDataNum.vue?vue&type=script&lang=js"
export * from "./TeleMarketDataNum.vue?vue&type=script&lang=js"
import style0 from "./TeleMarketDataNum.vue?vue&type=style&index=0&id=544bad31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544bad31",
  null
  
)

export default component.exports